import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CLIENT_REVIEW } from "../config/apiEndPoint";
import { GET, MULTIPART_POST, POST } from "config/api.config";

export const getClientReviewList = async (data = {}) => {
  try {
    const url = data?._Id
      ? `${CLIENT_REVIEW.GET_CLIENT_REVIEW_LIST}/${data?._Id}`
      : `${CLIENT_REVIEW.GET_CLIENT_REVIEW_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchClientReviewTableAndFilterSchema = async (data = {}) => {
  try {
    const url = data?._Id
      ? `${CLIENT_REVIEW.GET_CLIENT_REVIEW_SCHEMA}/${data?._Id}`
      : `${CLIENT_REVIEW.GET_CLIENT_REVIEW_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientReviewFilterData = async (data = {}) => {
  try {
    const response = await POST(CLIENT_REVIEW.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientReviewForEditByClientId = async (clientId = "") => {
  try {
    const resolvedClientId = String(clientId ?? "").trim();
    if (!resolvedClientId) {
      toast.error("Client id is missing");
      return null;
    }
    const response = await GET(CLIENT_REVIEW.GET_CLIENT_REVIEW_FOR_EDIT(resolvedClientId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientReviewData = async (data = {}) => {
  try {
    const response = await POST(CLIENT_REVIEW.ADD_CLIENT_REVIEW, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientReviewCurrentWeekRange = async () => {
  try {
    const response = await GET(CLIENT_REVIEW.GET_CURRENT_WEEK_RANGE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitUpsertData = async (data = {}) => {
  try {
    const response = await MULTIPART_POST(CLIENT_REVIEW.ADD_CLIENT_UPSERT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientReviewHireCandidates = async (clientId = "") => {
  try {
    const resolvedClientId = String(clientId ?? "").trim();
    if (!resolvedClientId) {
      toast.error("Client id is missing");
      return null;
    }
    const response = await GET(CLIENT_REVIEW.GET_HIRE_CANDIDATES(resolvedClientId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
